<div
  class="navbar-vertical"
  [class.collapsed]="collapsed"
  [class.expanded]="!collapsed"
>
  <!-- Logo always routes home -->
  <div class="logo-section">
    <a
      id="live-alerts-link"
      routerLink="/live-alerts"
      class="logo-link"
      aria-label="Live alerts"
    >
      @if (!collapsed) {
        <img
          id="full-logo"
          src="../../assets/logos/240110STO07_SH_Final_Logo_White.svg"
          class="logo logo-expanded"
          alt="Full Logo"
        />
      }
      @if (collapsed) {
        <img
          id="collapsed-logo"
          src="../../assets/logos/cropped-SH-favicon-alt2-270x270.png"
          class="logo logo-collapsed"
          alt="Collapsed Logo"
        />
      }
    </a>
  </div>

  <ul class="menu">
    <li>
      @if (collapsed) {
        <p-button
          variant="text"
          severity="secondary"
          id="openSearch"
          [link]="true"
          [pTooltip]="collapsed ? 'Search' : null"
          icon="pi pi-search"
          ariaLabel="Open search"
          styleClass="w-full border-noround p-block-2 open-search-btn"
          (click)="onSearchLinkClick()"
        ></p-button>
      } @else {
        <div class="p-3">
          <p-inputgroup>
            <input
              [disabled]="loadingSites"
              pInputText
              class="search-input pr-5"
              type="text"
              [(ngModel)]="searchText"
              (input)="search($event)"
              (focus)="focusFunction($event)"
              (keydown)="onKeyDown($event)"
              placeholder="Search"
            />
            <p-inputgroup-addon [class.loading-container]="loadingSites">
              @if (loadingSites) {
                <i class="pi pi-spin pi-spinner"></i>
              }
              @if (searchText && searchText.length > 0) {
                <i
                  class="pi pi-times icon-clear"
                  tabindex="0"
                  role="button"
                  aria-label="Clear search"
                  (click)="clearSearch()"
                  (keyup.enter)="clearSearch()"
                ></i>
              }
            </p-inputgroup-addon>
          </p-inputgroup>
        </div>
      }
    </li>
    <!-- collapse toggle as a menu item -->
    <li class="collapse-toggle-item">
      <a
        href="javascript:void(0)"
        (click)="toggle()"
        pTooltip="{{ collapsed ? 'Expand' : 'Collapse' }}"
        tooltipPosition="right"
        class="collapse-toggle-link"
        aria-label="Toggle navbar"
      >
        <app-icon [icon]="collapsed ? 'right-from-line' : 'left-from-line'"></app-icon>
        @if (!collapsed) {
          <span>{{ collapsed ? 'Expand' : 'Collapse' }}</span>
        }
      </a>
    </li>
    @for (item of menuItems; track item.label) {
      @if (!item.hidden) {
        @if (item.divider) {
          <hr class="divider" />
        }
        <li [class.submenu-open]="item.children && submenuStates[item.label]">
        <!-- No submenu -->
        @if (!item.children) {
          <a
            [routerLink]="item.route"
            routerLinkActive="active"
            [pTooltip]="collapsed ? item.label : null"
            tooltipPosition="right"
            (click)="onNavLinkClick()"
            [attr.aria-label]="item.ariaLabel"
          >
            <app-icon [icon]="item.icon"></app-icon>
            @if (!collapsed) {
              <span>{{ item.label }}</span>
            }
          </a>
        } @else {
          <!-- With submenu: use a real button so the control is focusable (anchor without href is not tabbable). -->
          <button
            type="button"
            class="submenu-toggle"
            (click)="toggleSubmenu(item.label)"
            [ngClass]="{ active: isChildRouteActive(item.children) }"
            [pTooltip]="collapsed ? item.label : null"
            tooltipPosition="right"
            [attr.aria-label]="item.ariaLabel ?? item.label"
            [attr.aria-expanded]="submenuStates[item.label]"
            [attr.aria-controls]="submenuPanelId(item.label)"
          >
            <app-icon [icon]="item.icon"></app-icon>
            @if (!collapsed) {
              <span>{{ item.label }}</span>
              <i
                class="pi"
                [ngClass]="submenuStates[item.label] ? 'pi-angle-down' : 'pi-angle-right'"
              ></i>
            }
          </button>

          <ul
            class="submenu"
            [id]="submenuPanelId(item.label)"
            [attr.inert]="submenuStates[item.label] ? null : ''"
            [@submenu]="submenuStates[item.label] ? 'open' : 'closed'"
          >
            @for (child of item.children; track child.label) {
              @if (!child.hidden) {
                <li>
                  <a
                    [routerLink]="child.route"
                    routerLinkActive="active"
                    [pTooltip]="collapsed ? child.label : null"
                    tooltipPosition="right"
                    (click)="onNavLinkClick()"
                    [attr.aria-label]="child.ariaLabel"
                  >
                    <app-icon [icon]="child.icon"></app-icon>
                    @if (!collapsed) {
                      <span>{{ child.label }}</span>
                    }
                  </a>
                </li>
              }
            }
          </ul>
        }
        </li>
      }
    }
    @if (showAdmin()) {
      <li>
        <hr class="divider" />
        <a
          [routerLink]="'/admin'"
          routerLinkActive="active"
          [pTooltip]="collapsed ? 'Admin' : null"
          tooltipPosition="right"
          (click)="onNavLinkClick()"
          aria-label="Admin panel"
        >
          <app-icon icon="user-light"></app-icon>
          @if (!collapsed) {
            <span>Admin</span>
          }
        </a>
      </li>
    }
  </ul>
  <!-- Bottom content wrapper -->
  <div class="bottom-wrapper">
    <!-- User avatar with tooltip -->
    <div
      class="user-section"
      pTooltip="Open user menu"
      tooltipPosition="right"
      [tooltipDisabled]="!collapsed"
    >
      <p-avatar
        icon="pi pi-user"
        shape="circle"
        style="background-color: #00f3bf; color: #11326b"
        (click)="openUserMenu($event)"
      />

      <p-menu
        #userDropdown
        [popup]="true"
        [model]="userMenu"
      ></p-menu>
    </div>

    <!-- Divider + version number -->
    <div
      class="version-section"
      [pTooltip]="collapsed ? shortVersionString : null"
      tooltipPosition="right"
    >
      <hr class="divider" />
      <div class="version-label">{{ shortVersionString }}</div>
    </div>
  </div>
</div>

<!-- Search Results popover -->
<p-popover #op>
  <div class="results-container">
    @if (results && results.length > 0) {
      <div class="scroll-container">
        @for (result of results; track result; let i = $index) {
          <div
            #row
            class="search-row"
            [class.active]="activeIndex === i"
            (mouseenter)="activeIndex = i"
          >
            <span
              role="button"
              tabindex="0"
              (click)="navigateToSite(result)"
              (keyup.enter)="navigateToSite(result)"
            >{{ result.display_name }}</span>
          </div>
        }
      </div>
    } @else {
      <div class="no-results">No results found.</div>
    }
  </div>
</p-popover>
